import "./App.scss";
import Header from "./common-header/Header";
import Footer from "./common-footer/Footer";
import Hero from "./Hero/Hero";
import Sections from "./Sections/Sections";

function App() {
  return (
    <div className="App">
      <Header clientName={"Roberto Coin"}/>
      <Hero />
      <Sections />
      <Footer />
    </div>
  );
}

export default App;
